import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import {
  fetchHomepageIfNeeded,
  setSelectedSidebarNav,
  fetchBudgetSubscribersIfNeeded,
  fetchBudgetSubscribersQuartersIfNeeded,
  fetchBudgetSubscribersExportIfNeeded,
  setSelectedMetricDateIfNeeded,
  logout
} from '../../actions'

import { makeBudgetSubscribersSelector, makeBudgetSubscribersExportStateSelector } from '../../selectors'
import BudgetSubscribersComponent from '../../components/budgetsubscribers/BudgetSubscribersComponent'
import SidebarComponent from '../../components/sidebar/SidebarComponent'
import Profile from '../../classes/profile'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'
import GoogleAnalytics from '../../classes/GoogleAnalytics'
import { BUDGET_SUBSCRIBERS_MODULE } from '../../constants/commons'

export class BudgetSubscribersContainer extends Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    history: PropTypes.object,
    match: PropTypes.object,
    logout: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string,
      metric_date: PropTypes.string
    }),
    fetchHomepage: PropTypes.func.isRequired,
    selectedNav: PropTypes.string,
    isContentIntelligence: PropTypes.bool,
    isCatalogAnalysis: PropTypes.bool,
    isPerformanceAnalysis: PropTypes.bool,
    isAIInsights: PropTypes.bool,
    selectedSidebarNav: PropTypes.func,
    budgetSubscribers: PropTypes.object,
    budgetSubscribersExport: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object
    }).isRequired,
    budgetSubscribersQuarters: PropTypes.object,
    fetchBudgetSubscribers: PropTypes.func,
    fetchBudgetSubscribersQuarters: PropTypes.func,
    fetchBudgetSubscribersExport: PropTypes.func,
    setSelectedMetricDate: PropTypes.func,
    selectedMetricDate: PropTypes.string
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(BUDGET_SUBSCRIBERS_MODULE, this.props.location, this.props.profile)
    this.fetchData ()
    if (this.props.shortcut) {
      this.props.fetchBudgetSubscribers(this.props.shortcut.metric_date)
      this.props.setSelectedMetricDate(this.props.shortcut.metric_date)
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.budgetSubscribersQuarters !== this.props.budgetSubscribersQuarters && this.props.budgetSubscribersQuarters.details && !this.props.shortcut) {
      const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
      if (homepage && homepage.details && homepage.details.is_budget_subscribers) {
        const quarters = this.props.budgetSubscribersQuarters.details.quarters
        this.props.fetchBudgetSubscribers(quarters[0].metric_date) //Lastest quarter is the default one
        this.props.setSelectedMetricDate(quarters[0].metric_date)
      }
    }
  }

  fetchData = () => {
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (!homepage) {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchHomepage(groupName)
      }
    }
    if (homepage && homepage.details && homepage.details.is_budget_subscribers) {
      this.props.fetchBudgetSubscribersQuarters()
    }
  }

  render () {
    const { profile, location, shortcut, selectedNav, isContentIntelligence, isCatalogAnalysis, isPerformanceAnalysis, isAIInsights, budgetSubscribers, budgetSubscribersQuarters, selectedMetricDate, setSelectedMetricDate, fetchBudgetSubscribers, fetchBudgetSubscribersExport, budgetSubscribersExport } = this.props
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    const myLogout = () => this.props.logout()
      return (
        <>
          <SidebarComponent
            isAdmin={this.props.isAdmin}
            profile={profile}
            logout={myLogout}
            location={location}
            homepage={homepage}
            shortcut={shortcut}
            selectedSidebarNav={this.props.selectedSidebarNav}
            selectedNav={selectedNav}
            isContentIntelligence={isContentIntelligence}
            isCatalogAnalysis={isCatalogAnalysis}
            isPerformanceAnalysis={isPerformanceAnalysis}
            isAIInsights={isAIInsights}
          />
          <BudgetSubscribersComponent
            isAdmin={this.props.isAdmin}
            shortcut={shortcut}
            homepage={homepage}
            budgetSubscribers={budgetSubscribers}
            budgetSubscribersQuarters={budgetSubscribersQuarters}
            setSelectedMetricDate={setSelectedMetricDate}
            selectedMetricDate={selectedMetricDate}
            fetchBudgetSubscribers={fetchBudgetSubscribers}
            fetchBudgetSubscribersExport={fetchBudgetSubscribersExport}
            budgetSubscribersExport={budgetSubscribersExport}
          />
        </>
      )
  }
}

function mapStateToProps () {
  const budgetSubscribersSelector = makeBudgetSubscribersSelector()
  const budgetSubscribersExportStateSelector = makeBudgetSubscribersExportStateSelector()
  return (state, ownProps) => {
    const profile = state.user.profile && new Profile(state.user.profile)
    const isAdmin = state.user.isAdmin
    const shortcut = ownProps.shortcut
    const homepage = state.homepage.list
    const selectedNav = state.sidebar.selectedNav
    const isContentIntelligence = state.sidebar.isContentIntelligence
    const isCatalogAnalysis = state.sidebar.isCatalogAnalysis
    const isPerformanceAnalysis = state.sidebar.isPerformanceAnalysis
    const isAIInsights = state.sidebar.isAIInsights
    const budgetSubscribers = budgetSubscribersSelector(state, ownProps)
    const budgetSubscribersExport = budgetSubscribersExportStateSelector(state, ownProps)
    const budgetSubscribersQuarters = state.budgetSubscribers.quarters
    const selectedMetricDate = state.budgetSubscribers.selectedMetricDate
    return {
      isAdmin,
      profile,
      shortcut,
      homepage,
      selectedNav,
      isContentIntelligence,
      isCatalogAnalysis,
      isPerformanceAnalysis,
      isAIInsights,
      budgetSubscribers,
      budgetSubscribersExport,
      budgetSubscribersQuarters,
      selectedMetricDate
    }
  }
}

function mapDispatchToProps (dispatch) {
  return {
    fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName)),
    selectedSidebarNav: (nav) => dispatch(setSelectedSidebarNav(nav)),
    fetchBudgetSubscribers: (metricDate, quarter) => dispatch(fetchBudgetSubscribersIfNeeded(metricDate, quarter)),
    fetchBudgetSubscribersQuarters: () => dispatch(fetchBudgetSubscribersQuartersIfNeeded()),
    fetchBudgetSubscribersExport: () => dispatch(fetchBudgetSubscribersExportIfNeeded()),
    setSelectedMetricDate: (metricDate) => dispatch(setSelectedMetricDateIfNeeded(metricDate)),
    logout: () => dispatch(logout())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BudgetSubscribersContainer)
